import { api } from "@/api/client";
import type { AuthUser } from "@/stores/auth";

export type TokenResponse = {
  access_token: string;
  token_type: string;
  expires_in: number;
};

export type AuthResponse = {
  user: AuthUser;
  token: TokenResponse;
};

export async function login(email: string, password: string): Promise<AuthResponse> {
  return api
    .post("auth/login", {
      json: { email, password },
      credentials: "include",
    })
    .json<AuthResponse>();
}

export async function register(input: {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  organization_name: string;
}): Promise<AuthResponse> {
  return api.post("auth/register", { json: input, credentials: "include" }).json<AuthResponse>();
}

export async function refresh(): Promise<AuthResponse> {
  return api
    .post("auth/refresh", { credentials: "include", retry: 0 })
    .json<AuthResponse>();
}

export async function logout(): Promise<void> {
  await api.post("auth/logout", { credentials: "include", retry: 0 });
}

export async function me(): Promise<AuthUser> {
  return api.get("auth/me").json<AuthUser>();
}
